import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { AiOutlineClose } from "react-icons/ai";
import api from "../../axios";
import "./box.css";
import { BsWhatsapp } from "react-icons/bs";

const Box = ({
  textContent,
  whatsapp_link = "https://wa.me/201027097226",
  confirmationMessage,
  courseTitle = "", // 👈 استقبلنا الـ title من Course.jsx
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isPaymentOpen, setIsPaymentOpen] = useState(false);
  const location = useLocation();

  const [formData, setFormData] = useState({
    name: "",
    email: "test@gmail.com",
    // country: "",
    phone: "",
    //  university: "",
    //  graduation_year: "",
    //  course: courseTitle || "", // 👈 استخدم العنوان اللي جاى من props
    registered_in: location.pathname,
  });

  // Sync لو العنوان اتغير
  useEffect(() => {
    setFormData((prev) => ({ ...prev, course: courseTitle || "" }));
  }, [courseTitle]);

  const handleButtonClick = () => {
    setIsOpen(true);
    setIsPaymentOpen(false);
  };

  const handleClose = () => {
    setIsOpen(false);
    setIsPaymentOpen(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    api
      .post("/contacts", { data: formData })
      .then(() => {
        alert(
          confirmationMessage ||
            "You've booked your offer, We will contact you as soon as possible!"
        );

        // Reset form data
        setFormData({
          name: "",
          email: "test@gmail.com",
          //     country: "",
          phone: "",
          //     university: "",
          //    graduation_year: "",
          //  course: courseTitle || "",
          registered_in: location.pathname,
        });

        // Close the popup
        handleClose();

        // Redirect to Google form if available
        if (textContent?.discount) {
          // Add a small delay to ensure the alert is seen
          setTimeout(() => {
            window.open(textContent.discount, "_blank");
          }, 500);
        }
      })
      .catch((e) => {
        console.error("Error:", e);
        alert("Invalid data");
      });
  };

  return (
    <div className="book">
      <div className="box">
        {/*
        <div className="text">
          <p>{textContent.discount}</p>
        </div>
         */}
        <div className="payment">
          <div className="button">
            <button onClick={handleButtonClick}>
              {location.pathname.includes("/events") ? "Join Now" : "Get Offer"}
            </button>
            <button id="chat">
              <a
                href={whatsapp_link}
                target="_blank"
                rel="noopener noreferrer"
                className="whatsapp"
              >
                Chat
                <BsWhatsapp size={15} />
              </a>
            </button>
            {isOpen && !isPaymentOpen && (
              <div className="paymentpopup">
                <div className="Popup-content">
                  <AiOutlineClose
                    className="close-icon"
                    onClick={handleClose}
                    size={35}
                    color="white"
                  />
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      {/*
                      <label htmlFor="email">
                        E-mail:
                        <input
                          type="email"
                          name="email"
                          placeholder="Your E-mail..."
                          value={formData.email}
                          onChange={(e) =>
                            setFormData({ ...formData, email: e.target.value })
                          }
                          required
                        />
                      </label>
                      */}
                    </div>

                    <label>
                      {/*
                      Country:
                      <input
                        type="text"
                        placeholder="Enter Your Country"
                        name="country"
                        value={formData.country}
                        onChange={(e) =>
                          setFormData({ ...formData, country: e.target.value })
                        }
                        required
                      />
                      */}
                      <label htmlFor="name">
                        Name:
                        <input
                          type="text"
                          name="name"
                          placeholder="Your Name..."
                          value={formData.name}
                          onChange={(e) =>
                            setFormData({ ...formData, name: e.target.value })
                          }
                          required
                        />
                      </label>
                      <label>
                        WhatsApp Number:
                        <input
                          type="text"
                          name="phoneNumber"
                          value={formData.phone}
                          onChange={(e) =>
                            setFormData({ ...formData, phone: e.target.value })
                          }
                          placeholder="Enter your phone number"
                          required
                        />
                      </label>
                    </label>

                    <div className="row">
                      {/*
                      <label htmlFor="university">
                        University:
                        <input
                          type="text"
                          name="university"
                          placeholder="Your University..."
                          value={formData.university}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              university: e.target.value,
                            })
                          }
                          required
                        />
                      </label>
                      <label htmlFor="grad-year">
                        Graduation Year:
                        <input
                          type="text"
                          name="graduationYear"
                          placeholder="Graduation Year..."
                          value={formData.graduation_year}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              graduation_year: e.target.value,
                            })
                          }
                          required
                        />
                      </label>
                      */}
                    </div>
                    <div className="next">
                      <button type="submit">Submit</button>
                    </div>
                  </form>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Box;
